import React, { useCallback } from "react";
import { BodyContainer } from "App/styles";
import ListOfEntries from "components/ListOfEntries";
import { MainTitle } from "components/MainTitle";
import { InputField, SelectField } from "basics";
import { CleanButton, YellowButton } from "basics/buttons";
import Pagination from "components/Pagination";
import { EntriesFilter, FilterActions, PaginationFooter } from "./styles";
import useEntriesList from "hooks/useEntriesList";
import { FormStatus } from "model/options";

/**
 * Listado de postulaciones de administración: abre en la edición vigente,
 * filtra por premio, estado y año, busca por proyecto, nombre, mail o teléfono
 * del postulado, exporta a Excel la cabecera de todo el resultado del filtro (y,
 * con un premio elegido, también las respuestas del cuestionario), permite
 * confirmar a mano las que quedaron en borrador y borrarlas (ver el modo `list` de `ListOfEntries`).
 */
export default function EntriesList() {
  const {
    exportEntries,
    emptyMessage,
    award,
    competition,
    status,
    entries,
    totalEntries,
    pageSize,
    currentPage,
    setPage,
    awards,
    handleFilter,
    handleSearch,
    searchKey,
    competitions,
    resetFilter,
    confirmEntry,
    copyConfirmationLink,
    deleteEntry,
    loading,
  } = useEntriesList();

  // Cambiar de página deja el scroll donde estaba, que es abajo (el paginador
  // vive al pie del listado): sin esto la página nueva se ve empezando por sus
  // últimas filas.
  const onPageChange = useCallback(
    (nextPage) => {
      setPage(nextPage);

      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    [setPage]
  );

  return (
    <BodyContainer>
      <MainTitle title="Listado" seoTitle="Listado" />

      <EntriesFilter>
        <InputField
          key={searchKey}
          id="search"
          className="search-field"
          label="Buscar"
          placeholder="Proyecto, nombre, mail o teléfono"
          onChange={handleSearch}
        />
        <SelectField
          id="award.id"
          value={award}
          options={awards}
          onChange={handleFilter}
          label="Premios"
          defaultOption="Todos los premios"
        />
        <SelectField
          id="currentStatus.type"
          value={status}
          options={FormStatus}
          onChange={handleFilter}
          label="Estados"
          defaultOption="Todos los estados"
        />
        <SelectField
          id="competition.id"
          value={competition}
          options={competitions}
          onChange={handleFilter}
          label="Competición"
          defaultOption="Todos los años"
        />

        <FilterActions>
          <CleanButton onClick={() => resetFilter()}>Limpiar</CleanButton>
          {/* El Excel sale de la cabecera de cada postulación, que es la misma
              para todos los premios: se exporta cualquier filtro con
              resultados. Las respuestas sólo alinean dentro de un premio, así
              que se suman recién cuando hay uno elegido. */}
          {totalEntries > 0 && (
            <YellowButton onClick={() => exportEntries()}>Exportar</YellowButton>
          )}
        </FilterActions>
      </EntriesFilter>

      <ListOfEntries
        entries={entries}
        mode="list"
        loading={loading}
        emptyMessage={emptyMessage}
        onConfirm={confirmEntry}
        onCopyLink={copyConfirmationLink}
        onDelete={deleteEntry}
      />

      <PaginationFooter>
        <Pagination
          currentPage={currentPage}
          totalItems={totalEntries}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </PaginationFooter>
    </BodyContainer>
  );
}
